/* eslint sort-keys: ["error", "asc", {caseSensitive: false}] */
import { buildScopedTranslationFunction, buildDangerouslyTranslateNeverWithUserContent } from '../../lib/translate';

const translate = buildScopedTranslationFunction({
  de: {
    greeting: 'Hallo',
    info: 'Bitte geben Sie das Passwort ein um fortzufahren',
    onPasswordSubmitError: `
      Wir konnten Ihnen keine Anleitung zum Zurücksetzen des Passworts zusenden.
      Wenn Sie keine Email hinterlegt haben, kontaktieren Sie Ihren Vorgesetzten.

    `,
    onPasswordSubmitSuccess:
      'Wenn Sie eine E-Mail-Adresse hinterlegt haben, erhalten Sie eine E-Mail um Ihr Passwort zurückzusetzen. Andernfalls wenden Sie sich bitte an Ihren Vorgesetzten.',
    password: 'Passwort',
    passwordFailed: 'Falsches Passwort. Bitte das korrekte Passwort angeben.',
    resetPassword: 'Passwort zurücksetzen',
    submit: 'Fortfahren',
    submitFailed: 'Anmelden fehlgeschlagen. Bitte Login und Passwort überprüfen.',
  },
  en: {
    greeting: 'Hello',
    info: 'Please enter your password to continue',
    onPasswordSubmitError: `
      We were not able to send you instruction to reset your password.
      If you don't have an email, contact your manager.
    `,
    onPasswordSubmitSuccess:
      'If you have an email address configured, you will receive an email to reset your password otherwise please contact your manager.',
    password: 'Password',
    passwordFailed: 'Wrong password. Please enter the correct password.',
    resetPassword: 'Reset Password',
    submit: 'Submit',
    submitFailed: 'Sign-in failed. Wrong credentials?',
  },
});

export const dangerouslyTranslateNeverWithUserContent = buildDangerouslyTranslateNeverWithUserContent(translate);
export default translate;
